// extracted by mini-css-extract-plugin
export default {"navigation":"Bp1iA","navigation-btn":"rVAW9","navigation-icon":"DzFDO"};